import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserDetailsBeResponse } from '../../models/users-models/user-details';
import { Auth0User } from '../../models/auth0User';
import { Account } from '../../models/account';
import { GdprConsent } from '../../components/global/consent/consent.service';
import { LocationData } from '../../models/location-data';
import { HttpErrorResponse } from '@angular/common/http';

// dispatch this action when user logs out.
export const logout = createAction('[CORE] logout');

export const updateGoogleMapsApiLoaded = createAction('[CORE] update googleMapsApiLoaded',
    props<{ googleMapsApiLoaded: boolean }>());

export const noop = createAction('[CORE] noop');

export const CoreUserActions = createActionGroup({
  source: 'CORE - USER',
  events: {
    updateUser: props<{ user: Auth0User }>(),
    updateUserDetails: props<{ userDetails: UserDetailsBeResponse }>(),
    updateUserLanguage: props<{ languageShort: string }>(),
    updateUserLanguageSuccess: props<{ languageShort: string }>(),
  },
});

export const CoreLocationDataActions = createActionGroup({
  source: 'CORE - LOCATION DATA',
  events: {
    getLocationData: emptyProps(),
    locationDataLoading: props<{ loading: boolean }>(),
    getLocationDataSuccess: props<{ locationData: LocationData[] }>(),
    getLocationDataError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
  },
});

export const updateSelectedAccount = createAction('[CORE] Update selected account',
    props<{ selectedAccount: Account }>());
export const updateGdprConsent = createAction('[CORE] Update GDPR consent',
    props<{ gdprConsent: GdprConsent }>());

export const ManagedLocationCountActions = createActionGroup({
  source: 'CORE',
  events: {
    'Load Managed Location Count': emptyProps(),
    'Load Managed Location Count Success': props<{ count: number }>(),
    'Load Managed Location Count Failure': props<{ error: any }>(),
    'Refresh Managed Location Count': emptyProps(),
    'Refresh Managed Location Count Success': props<{ count: number }>(),
    'Refresh Managed Location Count Failure': props<{ error: any }>(),
  },
});

